const { useEffect } = require('react');

const SEARCH_SHORTCUT_KEY = 'k';

/**
 * Calls `onTrigger` on Cmd + K (mac) or Ctrl + K (win/linux), anywhere in the
 * app. The default is prevented because Ctrl/Cmd + K is bound to the browser
 * address bar in Firefox — so when `enabled` is false nothing is bound at all,
 * leaving the browser shortcut untouched for users without the feature.
 */
const useGlobalSearchShortcut = (onTrigger, enabled = true) => {
  useEffect(() => {
    if (!enabled || typeof document === 'undefined') {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (!event.metaKey && !event.ctrlKey) {
        return;
      }
      if (event.key?.toLowerCase() !== SEARCH_SHORTCUT_KEY) {
        return;
      }
      event.preventDefault();
      onTrigger();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [enabled, onTrigger]);
};

module.exports = useGlobalSearchShortcut;
